import { Column } from '@melements/front-components/dist/components/list/table/Table.types';

import { EditButton } from './editButton/EditButton';
import { StatusIcon } from './statusIcon/StatusIcon';

// tslint:disable-next-line:prefer-array-literal
const COLUMNS_ARRAY: Array<Column<any>> = [
  {
    key: 'tppName',
    name: { id: 'TPPS.TABLE.COLUMNS.TPP_NAME' },
  },
  {
    key: 'tppId',
    name: { id: 'TPPS.TABLE.COLUMNS.TPP_ID' },
  },
  {
    key: 'country',
    name: { id: 'TPPS.TABLE.COLUMNS.COUNTRY' },
  },
  {
    component: StatusIcon,
    key: 'pis',
    name: { id: 'TPPS.TABLE.COLUMNS.PIS' },
  },
  {
    component: StatusIcon,
    key: 'ais',
    name: { id: 'TPPS.TABLE.COLUMNS.AIS' },
  },
  {
    component: StatusIcon,
    key: 'caf',
    name: { id: 'TPPS.TABLE.COLUMNS.CAF' },
  },
  {
    component: EditButton,
    key: 'action',
    name: { id: 'TPPS.TABLE.COLUMNS.ACTION' },
  },
];

export const COLUMNS = [COLUMNS_ARRAY];
